import React, { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';

import { useEffect } from 'react'
import axios from "axios";

import { endPoints } from "../../Constants";
import { Link } from 'react-router-dom';
import { useTranslation,Trans  } from 'react-i18next';

const Faq = () => {
   const { t,i18n  } = useTranslation();
  const [activeKey, setActiveKey] = useState("0");

  // Function to handle accordion item click
  const handleAccordionClick = (eventKey) => {
    // Toggle activeKey: if clicked item is already active, deactivate it; otherwise, activate it
    setActiveKey(activeKey === eventKey ? null : eventKey);
  };

  const [myFaq, setFaq] = useState([]);


  useEffect(() => {
    const token = localStorage.getItem('token');

    axios.get(`${endPoints.faq}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then((res) => {
        const limitedFaqs = res.data.slice(0, 5);
        setFaq(limitedFaqs);

      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  }, []);

  return (
    <>
      <section className="lyt-section typ-faq-sec" id='faqh'>
        <div className="container">
          <div className="heading-wrapper">
            <div>
         
              <h2 className="bs-heading typdblue mb-2" data-aos="fade-in" data-aos-delay="200">{t('faqTitle')}</h2>
              <p className="bs-para typblue" data-aos="fade-in" data-aos-delay="300">{t('faqDesc')}</p>
            </div>

            <Link className="bs-btn" to="/faq" aria-label="Navigate to Contact Us page" data-aos="fade-in" data-aos-delay="200">
              {t('viewAll')} <span className="icon icon-right-arrow"></span>
            </Link>
          </div>
 
          <Accordion
            activeKey={activeKey} onSelect={handleAccordionClick}
            className='bs-accordion'
            data-aos="fade-in" data-aos-delay="200"
          >
           
            {myFaq.map((item, index) => {
              const { faQ_QUESTION, faQ_ANSWER,faQ_QUESTION_Mr,faQ_ANSWER_Mr } = item;
               // Pick question & answer based on language
              const question = i18n.language === 'mr' ? faQ_QUESTION_Mr : faQ_QUESTION;
              const answer = i18n.language === 'mr' ? faQ_ANSWER_Mr : faQ_ANSWER;

              return (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={index}
                  className={activeKey === index.toString() ? 'active' : ''}
                >
                  <Accordion.Header>{question}</Accordion.Header>
                  <Accordion.Body>
                    <div className='question-wrapper'>
                      {answer}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}

          </Accordion>

        </div>
      </section>
    </>
  );
};

export default Faq;
